const AUTH_PREFIX = "/auth";
const ADMIN_PREFIX = "/admin";
const USER_PREFIX = "/cal-user";

export const API_ROUTES = {
  // Verify Token
  VERIFY_TOKEN: `${process.env.REACT_APP_API_BASE_PATH}/verify`,
  //Auth Routes
  ADMIN_LOGIN: `${process.env.REACT_APP_API_BASE_PATH}${AUTH_PREFIX}${ADMIN_PREFIX}/login`,
  ADMIN_REGISTER: `${process.env.REACT_APP_API_BASE_PATH}${AUTH_PREFIX}${ADMIN_PREFIX}/register`,

  USER_LOGIN: `${process.env.REACT_APP_API_BASE_PATH}${AUTH_PREFIX}${USER_PREFIX}/login`,
  USER_REGISTER: `${process.env.REACT_APP_API_BASE_PATH}${AUTH_PREFIX}${USER_PREFIX}/register`,

  LOGOUT: `${process.env.REACT_APP_API_BASE_PATH}${AUTH_PREFIX}/logout`,

  // USER ROUTES
  USER_LIST: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user`,
  USER_DATA: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user/data`,
  USER_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user/create`,
  USER_EDIT: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user/update`,
  USER_PASSWORD_EDIT: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user/update-password`,
  USER_DELETE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/user/delete`,

  // Zone ROUTES
  ZONE_LIST: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone`,
  ZONE_DATA: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone/data`,
  ZONE_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone/create`,
  ZONE_EDIT: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone/update`,
  ZONE_DELETE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone/delete`,

  // Zone Items ROUTES
  ZONE_ITEMS_LIST: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone-items`,
  ZONE_ITEMS_DATA: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone-items/data`,
  ZONE_ITEMS_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone-items/create`,
  ZONE_ITEMS_EDIT: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone-items/update`,
  ZONE_ITEMS_DELETE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/zone-items/delete`,

  // Customer ROUTES
  CUSTOMER_LIST: `${process.env.REACT_APP_API_BASE_PATH}/customer`,
  CUSTOMERDATA: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/customer/data`,
  CUSTOMER_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/customer/create`,
  CUSTOMER_EDIT: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/customer/update`,
  CUSTOMER_DELETE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/customer/delete`,

  // Fee ROUTES
  FEE_DATA: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/fee`,
  FEE_UPDATE: `${process.env.REACT_APP_API_BASE_PATH}${ADMIN_PREFIX}/fee/update`,

  // Start Location
  START_LOCATION_LIST: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/start-location/list`,
  START_LOCATION_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/start-location/create`,

  // Packing Materials
  PACKING_MATERIAL_LIST: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/packing-materials/list`,
  PACKING_MATERIAL_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/packing-materials/create`,

  // Proposal List
  PR_LIST: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/list`,
  PR_ITEM_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/zone-item/create`,

  /********* Proposal Wizard *********/
  PR_COMPLETE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/complete`,

  // Customer Data Routes
  PR_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/customer-data/create`,
  PR_UPDATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/customer-data/update`,

  PR_CUSTOMER_DATA: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/customer-data`,
  // Tour Plan Data Routes
  PR_TOURPLAN_CREATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/tour-data/create`,
  PR_TOURPLAN_LIST: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/tour-data/list`,
  PR_TOURPLAN_INFORMATION_UPDATE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/tour-information/update`,
  // Tour Plan Item List
  PR_TOURPLAN_ITEM_LIST: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/tour-items/list`,
  PR_TOURPLAN_ITEM_SAVE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/tour-items/save`,
  // Tour Plan logistic data
  PR_TOURPLAN_LOGISTIC_DATA: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/logistic-data/data`,
  PR_TOURPLAN_LOGISTIC_DATA_SAVE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/logistic-data/save`,
  // Tour Plan summery data
  PR_TOURPLAN_SUMMERY_DATA: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/summary-data/data`,
  PR_TOURPLAN_SUMMERY_DATA_SAVE: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/summary-data/save`,
  // Tour Plan summery data
  PR_TOURPLAN_GET_SUMMERY: `${process.env.REACT_APP_API_BASE_PATH}${USER_PREFIX}/proposal/summary-data/get-summary`,
};
